import { useEffect, useState } from "react";
import api from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Store, Phone, MapPin } from "lucide-react";

export default function RetailersPublicPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/retailers/public").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const filtered = items.filter((r) => !q || r.name?.toLowerCase().includes(q.toLowerCase()) || r.area?.toLowerCase().includes(q.toLowerCase()));
  return (
    <>
      <PublicHeader />
      <section className="bg-gradient-to-br from-[#0F172A] to-[#1E3A8A] text-white">
        <div className="max-w-5xl mx-auto px-4 py-10">
          <div className="flex items-center gap-3 mb-2"><Store className="w-5 h-5 text-amber-300"/>
            <span className="uppercase tracking-[0.28em] text-[11px] text-amber-300 font-black">Retailer Network</span></div>
          <h1 className="font-devnagri-heading text-4xl font-black">हमारे <span className="text-amber-300">अख़बार वितरक</span></h1>
        </div>
      </section>
      <main className="max-w-5xl mx-auto px-4 py-8" data-testid="retailers-page">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="नाम या क्षेत्र खोजें…"
          className="w-full h-11 px-4 rounded-md border border-slate-200 mb-6" data-testid="retailer-search"/>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((r, i) => (
            <div key={r.retailer_code || `${r.name}-${r.phone}-${i}`} className="bg-white border border-slate-200 rounded-lg p-4" data-testid={`retailer-${i}`}>
              <div className="font-bold text-[#0F172A]">{r.name}</div>
              <div className="text-xs text-[#EA580C] uppercase tracking-widest font-bold">{r.retailer_code}</div>
              <div className="mt-2 space-y-1 text-sm">
                {r.phone && <div className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-slate-400"/><a href={`tel:${r.phone}`} className="hover:text-[#DC2626]">{r.phone}</a></div>}
                {r.area && <div className="flex items-center gap-2 text-slate-600"><MapPin className="w-3.5 h-3.5 text-slate-400"/>{r.area}</div>}
              </div>
            </div>
          ))}
        </div>
      </main>
      <PublicFooter />
    </>
  );
}
